module.exports = __webpack_public_path__ + "75ae47f7267c93a735446704b2f3225d.pdf";